module.exports = __webpack_public_path__ + "static/media/Facebook.2e24ee50.svg";